var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNewProjectPptActive = function SvgIconNewProjectPptActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5BFFC",
    fillRule: "evenodd",
    d: "M20 6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-1a2 2 0 0 1 2-2h1a2 2 0 0 0 2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4276EE",
    d: "M21 6.75v8.507c0 1.002-.39 1.944-1.099 2.652l-1.992 1.992A3.73 3.73 0 0 1 15.257 21H6.75A3.754 3.754 0 0 1 3 17.25V6.75A3.754 3.754 0 0 1 6.75 3h10.5A3.754 3.754 0 0 1 21 6.75M6.75 19.5h7.5v-3c0-1.24 1.01-2.25 2.25-2.25h3v-7.5c0-1.24-1.01-2.25-2.25-2.25H6.75C5.51 4.5 4.5 5.51 4.5 6.75v10.5c0 1.24 1.01 2.25 2.25 2.25m12.09-2.651c.307-.306.51-.686.602-1.099H16.5a.75.75 0 0 0-.75.75v2.942a2.24 2.24 0 0 0 1.099-.601z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4276EE",
    fillRule: "evenodd",
    d: "M15 9.944c0 1.622-1.36 2.943-3.034 2.943l-1.081.005v2.181a.935.935 0 0 1-.943.927.935.935 0 0 1-.942-.927V7.927C9 7.415 9.422 7 9.942 7h2.024C13.638 7 15 8.321 15 9.944m-3.034-1.09c.623 0 1.15.5 1.15 1.09s-.527 1.09-1.15 1.09l-1.07.004-.008-2.184z",
    clipRule: "evenodd"
  })));
};
export default SvgIconNewProjectPptActive;